import { debounce } from "lodash";
import moment from "moment";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import * as CommitteeMeetingActions from "../../../actions/committeeMeeting";
import * as CommitteeMeetingAttendanceActions from "../../../actions/committeeMeetingAttendance";
import * as CommitteeActions from "../../../actions/committees";
import * as NavigationActions from "../../../actions/navigation";
import { NotificationAlert } from "../../../components/common/index";
import { CheckboxFormInput, TextAreaFormInput } from "../../../components/form";
import { SelectFormInput } from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { createPersonnelSearchLoader } from "../../../functions/personnel";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { CommitteeMeetingAttendanceCreateBreadcrumbs, CommitteeMeetingAttendanceDetailsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { CommitteeMeetingAttendanceSubMenu } from "../../../helpers/subMenuHelper";
import useNavigate from "../../../hooks/useNavigate";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { ICommitteeMeetingAttendanceReduxFormState } from "../../../reducers/reactReduxForms/committeeMeetingAttendance";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./CommitteeMeetingAttendancePage.scss";

interface CommitteeMeetingAttendancePageProps {
    form: Dtos.CommitteeMeetingAttendance & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ICommitteeMeetingAttendanceReduxFormState;
    committeeMeetingAttendance: Dtos.CommitteeMeetingAttendance;
    committeeMeeting: Dtos.CommitteeMeeting | undefined;
    committee: Dtos.Committee | undefined;
    lookups: Dtos.Lookup[];
    loadingCommitteeMeetingAttendance: boolean;
    loadCommitteeMeetingAttendanceSuccess: boolean;
    loadCommitteeMeetingAttendanceFailure: boolean;
    loadCommitteeMeetingAttendanceErrorCode: string;
    savingCommitteeMeetingAttendance: boolean;
    saveCommitteeMeetingAttendanceSuccess: boolean;
    saveCommitteeMeetingAttendanceFailure: boolean;
    creatingCommitteeMeetingAttendance: boolean;
    createCommitteeMeetingAttendanceSuccess: boolean;
    createCommitteeMeetingAttendanceFailure: boolean;
    validatingCommitteeMeetingAttendance: boolean;
    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;
    loadCommitteeErrorCode: string;
    loadingCommitteeMeeting: boolean;
    loadCommitteeMeetingSuccess: boolean;
    loadCommitteeMeetingFailure: boolean;
    loadCommitteeMeetingErrorCode: string;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearCommitteeMeetingAttendance: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceClearActionCreator;
    loadCommitteeMeetingAttendance: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceLoadByIdActionCreator;
    saveCommitteeMeetingAttendance: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceSaveActionCreator;
    createCommitteeMeetingAttendance: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceCreateActionCreator;
    validateCommitteeMeetingAttendance: CommitteeMeetingAttendanceActions.ICommitteeMeetingAttendanceValidateActionCreator;
    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;
    clearCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingClearActionCreator;
    loadCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingLoadByIdActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.committeeMeetingAttendance";

const CommitteeMeetingAttendancePage: FC<CommitteeMeetingAttendancePageProps> = ({
    form,
    formState,
    formProperties,
    //reduxFormState,
    committeeMeetingAttendance,
    committeeMeeting,
    committee,
    lookups,
    loadingCommitteeMeetingAttendance,
    //loadCommitteeMeetingAttendanceSuccess,
    loadCommitteeMeetingAttendanceFailure,
    loadCommitteeMeetingAttendanceErrorCode,
    savingCommitteeMeetingAttendance,
    saveCommitteeMeetingAttendanceSuccess,
    saveCommitteeMeetingAttendanceFailure,
    creatingCommitteeMeetingAttendance,
    //createCommitteeMeetingAttendanceSuccess,
    //createCommitteeMeetingAttendanceFailure,
    validatingCommitteeMeetingAttendance,
    loadingCommittee,
    //loadCommitteeSuccess,
    loadCommitteeFailure,
    loadCommitteeErrorCode,
    loadingCommitteeMeeting,
    //loadCommitteeMeetingSuccess,
    loadCommitteeMeetingFailure,
    loadCommitteeMeetingErrorCode,
    validationFailures,
    permissions,
    clearCommitteeMeetingAttendance,
    loadCommitteeMeetingAttendance,
    saveCommitteeMeetingAttendance,
    createCommitteeMeetingAttendance,
    validateCommitteeMeetingAttendance,
    clearCommittee,
    loadCommittee,
    clearCommitteeMeeting,
    loadCommitteeMeeting,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { committeeId } = useParams<{ committeeId: string }>();
    const { committeeMeetingId } = useParams<{ committeeMeetingId: string }>();
    const { committeeMeetingAttendanceId } = useParams<{ committeeMeetingAttendanceId: string }>();
    const committeeIdNumber = parseInt(committeeId, 10);
    const committeeMeetingIdNumber = parseInt(committeeMeetingId, 10);
    const committeeMeetingAttendanceIdNumber = parseInt(committeeMeetingAttendanceId, 10);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    const loadReduxForm = () => {
        let extraData: Dtos.CommitteeMeetingAttendance = {} as Dtos.CommitteeMeetingAttendance;

        loadForm(reduxFormName, Object.assign({ ...committeeMeetingAttendance }, extraData));
    };

    const getCommitteeMeetingName = (committeeMeeting: Dtos.CommitteeMeeting): string => {
        if (!committeeMeeting) return "Meeting";

        const parts: string[] = [];

        if (committeeMeeting.meetingDate) {
            parts.push(moment(committeeMeeting.meetingDate, "YYYY-MM-DD HH:mm:ss.SSSSSSS Z").format("DD/MM/YYYY"));
        }

        if (committeeMeeting.location) parts.push(committeeMeeting.location);
        if (committeeMeeting.room) parts.push(committeeMeeting.room);
        if (committeeMeeting.time) parts.push(committeeMeeting.time);

        return parts.join(" - ") || "Meeting";
    }


    // Load/Create committee meeting attendance
    useEffect(() => {
        if (committeeMeetingAttendanceIdNumber && !committeeMeetingAttendance && !loadingCommitteeMeetingAttendance) {
            setDrawerItems(
                CommitteeMeetingAttendanceSubMenu(
                    committeeIdNumber,
                    committeeMeetingIdNumber,
                    committeeMeetingAttendanceIdNumber,
                    permissions
                )
            );
            setBreadcrumbs(
                CommitteeMeetingAttendanceDetailsBreadcrumbs(
                    committeeIdNumber,
                    committeeMeetingIdNumber,
                    committeeMeetingAttendanceIdNumber
                )
            );
            loadCommitteeMeetingAttendance(committeeMeetingAttendanceIdNumber);
        } 
        else if (!committeeMeetingAttendanceIdNumber && !committeeMeetingAttendance && !creatingCommitteeMeetingAttendance) {
            setDrawerItems([]);
            setBreadcrumbs(
                CommitteeMeetingAttendanceCreateBreadcrumbs(
                    committeeIdNumber,
                    committeeMeetingIdNumber
                )
            );
            createCommitteeMeetingAttendance(committeeMeetingIdNumber);
        } else if (committeeMeetingAttendance && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        committeeIdNumber,
        committeeMeetingIdNumber,
        committeeMeetingAttendanceIdNumber,
        committeeMeetingAttendance,
        loadingCommitteeMeetingAttendance,
        permissions,
        creatingCommitteeMeetingAttendance,
        initalised
    ]);

    // Load committee meeting
    useEffect(() => {
        if (committeeMeetingIdNumber && !committeeMeeting && !loadingCommitteeMeeting) {
            loadCommitteeMeeting(committeeMeetingIdNumber);
        }
    }, [committeeMeetingIdNumber, committeeMeeting, loadingCommitteeMeeting]);

    // Load committee
    useEffect(() => {
        if (committeeIdNumber && !committee && !loadingCommittee) {
            loadCommittee(committeeIdNumber);
        }
    }, [committeeIdNumber, committee, loadingCommittee]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadCommitteeFailure) {
            navigate(`/error/${loadCommitteeErrorCode}`);
        }
        if (loadCommitteeMeetingFailure) {
            navigate(`/error/${loadCommitteeMeetingErrorCode}`);
        }
        if (loadCommitteeMeetingAttendanceFailure) {
            navigate(`/error/${loadCommitteeMeetingAttendanceErrorCode}`);
        }
    }, [
        loadCommitteeFailure, 
        loadCommitteeErrorCode,
        loadCommitteeMeetingFailure,
        loadCommitteeMeetingErrorCode,
        loadCommitteeMeetingAttendanceFailure,
        loadCommitteeMeetingAttendanceErrorCode
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (committeeMeetingAttendanceIdNumber && committeeMeetingAttendance && committeeMeeting && committee) {
            setBreadcrumbs(
                CommitteeMeetingAttendanceDetailsBreadcrumbs(
                    committeeIdNumber,
                    committeeMeetingIdNumber,
                    committeeMeetingAttendanceIdNumber,
                    committee.name,
                    getCommitteeMeetingName(committeeMeeting),
                    committeeMeetingAttendance?.personnel?.displayWithSalutation
                )
            );
        }
        else if (!committeeMeetingAttendanceIdNumber && committeeMeeting && committee) {
            setBreadcrumbs(
                CommitteeMeetingAttendanceCreateBreadcrumbs(
                    committeeIdNumber,
                    committeeMeetingIdNumber,
                    committee?.name,
                    getCommitteeMeetingName(committeeMeeting)
                )
            );
        }
    }, [
        committeeMeetingAttendanceIdNumber,
        committeeMeetingIdNumber,
        committeeIdNumber,
        committeeMeetingAttendance,
        committeeMeeting,
        committee
    ]);

    // Reload committee meeting attendance after saving
    useEffect(() => {
        if (!savingCommitteeMeetingAttendance && saveCommitteeMeetingAttendanceSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Committee Meeting Attendance saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(`/committees/${committeeIdNumber}/meetings/${committeeMeetingIdNumber}/attendances`);
            } 
            else if (!committeeMeetingAttendanceIdNumber) {
                navigate(`/committees/${committeeIdNumber}/meetings/${committeeMeetingIdNumber}/attendances/${committeeMeetingAttendance.id}/details`);
                clearCommitteeMeetingAttendance();
            }
        }
    }, [
        savingCommitteeMeetingAttendance,
        saveCommitteeMeetingAttendanceSuccess,
        saveAndReturn,
        committeeIdNumber,
        committeeMeetingIdNumber,
        committeeMeetingAttendanceIdNumber,
        committeeMeetingAttendance
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingCommitteeMeetingAttendance && saveCommitteeMeetingAttendanceFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingCommitteeMeetingAttendance, saveCommitteeMeetingAttendanceFailure]);

    // Cleanup effect to clear the committee meeting attendance on component unmount
    useEffect(() => {
        return () => {
            clearCommitteeMeetingAttendance();
            clearCommitteeMeeting();
            clearCommittee();
            resetForm(reduxFormName);
        };
    }, [clearCommitteeMeetingAttendance, clearCommitteeMeeting, clearCommittee, resetForm, reduxFormName]);

    const onCancel = () => {
        navigate(`/committees/${committeeIdNumber}/meetings/${committeeMeetingIdNumber}/attendances`);
    };

    const handleOnSubmitFailed = (_data: Dtos.CommitteeMeetingAttendance) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.CommitteeMeetingAttendance = {} as Dtos.CommitteeMeetingAttendance;

            await saveCommitteeMeetingAttendance(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.CommitteeMeetingAttendance = {} as Dtos.CommitteeMeetingAttendance;

            if (form && hasBeenSubmitted && !validatingCommitteeMeetingAttendance) {
                await validateCommitteeMeetingAttendance(Object.assign({ ...form }, changes));
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const personnelSearchLoader = useMemo(() => {
        return createPersonnelSearchLoader(
            form?.personnel 
                ? { label: form?.personnel?.displayWithSalutation, value: form?.personnelId } as Dtos.PersonnelOption 
                : null
        );
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.CommitteeMeetingAttendanceUpdate
        );
        const formDisabled: boolean =
            !hasPermission ||
            savingCommitteeMeetingAttendance ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row py-4 px-4">
                                <div className="col-md-5">
                                    {renderFormControls(
                                        form,
                                        "committeeMeetingAttendance",
                                        {
                                            personnelId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    value: form?.personnelId ?? null,
                                                    cacheOptions: true,
                                                    defaultOptions: form?.personnel
                                                        ? [{ label: form.personnel.displayWithSalutation, value: form.personnel.id }]
                                                        : null,
                                                    placeholder: "Type to search for personnel...",
                                                    clearable: true,
                                                    loadOptions: personnelSearchLoader,
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-3",
                                                fieldClassName: "col-sm-8 generic-form-field pl-4 mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-5">
                                    {renderFormControls(
                                        form,
                                        "committeeMeetingAttendance",
                                        {
                                            committeeMeetingAttendanceStatusId:
                                                {
                                                    type: RegistrationComponent.RegistrationControl,
                                                    inputType: SelectFormInput,
                                                    inputDisabled: formDisabled,
                                                    inputProps: {
                                                        options:
                                                            generateOptionsFromLookup(
                                                                findLookup(
                                                                    "committeeMeetingAttendance",
                                                                    "committeeMeetingAttendanceStatusId",
                                                                    lookups
                                                                ),
                                                                form.committeeMeetingAttendanceStatusId
                                                            ),
                                                    },
                                                    groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                    labelClassName: "col-form-label col-sm-3",
                                                    fieldClassName: "col-sm-9 generic-form-field pl-4 mr-0 pr-0",
                                                },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-2">
                                    {renderFormControls(
                                        form,
                                        "committeeMeetingAttendance",
                                        {
                                            active: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Active",
                                                },
                                                inputLabel: " ",
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-2",
                                                labelClassName: "col-form-label col-sm-5",
                                                fieldClassName: "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            commentGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Comments</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeMeetingAttendance",
                                        {
                                            comment: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName: "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "committeeMeetingAttendance",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(`${reduxFormName}.saveAndReturn`, true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={onCancel}
                        className="btn btn-primary mr-2"
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        permissions,
        savingCommitteeMeetingAttendance,
        formState,
        form,
        personnelSearchLoader,
        lookups,
        validationFailures,
        formProperties,
        changeForm,
        generateOptionsFromLookup,
        findLookup,
        reduxFormName,
        handleOnSubmit,
        handleOnSubmitFailed,
        onCancel
    ]);
    
    return (
        <RestrictedLayout
            loading={
                loadingCommitteeMeetingAttendance ||
                creatingCommitteeMeetingAttendance ||
                loadingCommitteeMeeting ||
                loadingCommittee
            }
            permission={Dtos.Permission.CommitteeMeetingAttendanceView}
        >
            { renderContent }
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<CommitteeMeetingAttendancePageProps> => {
    let committeeMeetingAttendance: Dtos.CommitteeMeetingAttendance | undefined = !(state.committeeMeetingAttendance.formData instanceof Array)
            ? state.committeeMeetingAttendance.formData
            : undefined;
    let committeeMeeting: Dtos.CommitteeMeeting | undefined = !(state.committeeMeeting.formData instanceof Array)
            ? state.committeeMeeting.formData
            : undefined;
    let committee: Dtos.Committee | undefined = !(state.committees.formData instanceof Array)
        ? state.committees.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        committeeMeetingAttendance: committeeMeetingAttendance!,
        committeeMeeting: committeeMeeting!,
        committee: committee!,

        loadingCommitteeMeetingAttendance:
            state.committeeMeetingAttendance.loadState &&
            state.committeeMeetingAttendance.loadState.status == RequestState.Pending,
        loadCommitteeMeetingAttendanceSuccess:
            state.committeeMeetingAttendance.loadState &&
            state.committeeMeetingAttendance.loadState.status == RequestState.Success,
        loadCommitteeMeetingAttendanceFailure:
            state.committeeMeetingAttendance.loadState &&
            state.committeeMeetingAttendance.loadState.status == RequestState.Failure,
        loadCommitteeMeetingAttendanceErrorCode: state.committeeMeetingAttendance.loadState.errorCode,

        savingCommitteeMeetingAttendance:
            state.committeeMeetingAttendance.saveState &&
            state.committeeMeetingAttendance.saveState.status == RequestState.Pending,
        saveCommitteeMeetingAttendanceSuccess:
            state.committeeMeetingAttendance.saveState &&
            state.committeeMeetingAttendance.saveState.status == RequestState.Success,
        saveCommitteeMeetingAttendanceFailure:
            state.committeeMeetingAttendance.saveState &&
            state.committeeMeetingAttendance.saveState.status == RequestState.Failure,

        creatingCommitteeMeetingAttendance:
            state.committeeMeetingAttendance.createState &&
            state.committeeMeetingAttendance.createState.status == RequestState.Pending,
        createCommitteeMeetingAttendanceSuccess:
            state.committeeMeetingAttendance.createState &&
            state.committeeMeetingAttendance.createState.status == RequestState.Success,
        createCommitteeMeetingAttendanceFailure:
            state.committeeMeetingAttendance.createState &&
            state.committeeMeetingAttendance.createState.status == RequestState.Failure,

        validatingCommitteeMeetingAttendance:
            state.committeeMeetingAttendance.validateState &&
            state.committeeMeetingAttendance.validateState.status == RequestState.Pending,

        loadingCommittee:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Failure,
        loadCommitteeErrorCode: state.committees.loadState.errorCode,

        loadingCommitteeMeeting:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Pending,
        loadCommitteeMeetingSuccess:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Success,
        loadCommitteeMeetingFailure:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Failure,
        loadCommitteeMeetingErrorCode: state.committeeMeeting.loadState.errorCode,

        permissions: permissions,
        lookups: state.committeeMeetingAttendance.lookups,

        form: state.reduxForms.committeeMeetingAttendance,
        formState: state.committeeMeetingAttendance.formState,
        formProperties: state.committeeMeetingAttendance.formProperties,

        reduxFormState: state.reduxForms.formState.committeeMeetingAttendance,
        validationFailures: committeeMeetingAttendance
            ? state.committeeMeetingAttendance.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<CommitteeMeetingAttendancePageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadCommitteeMeetingAttendance: bindActionCreators(
            CommitteeMeetingAttendanceActions.LoadCommitteeMeetingAttendanceById,
            dispatch
        ),
        clearCommitteeMeetingAttendance: bindActionCreators(
            CommitteeMeetingAttendanceActions.Clear,
            dispatch
        ),

        loadCommittee: bindActionCreators(CommitteeActions.LoadCommitteeById, dispatch),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        loadCommitteeMeeting: bindActionCreators(CommitteeMeetingActions.LoadCommitteeMeetingById, dispatch),
        clearCommitteeMeeting: bindActionCreators(CommitteeMeetingActions.Clear, dispatch),

        saveCommitteeMeetingAttendance: bindActionCreators(
            CommitteeMeetingAttendanceActions.SaveCommitteeMeetingAttendance,
            dispatch
        ),
        createCommitteeMeetingAttendance: bindActionCreators(
            CommitteeMeetingAttendanceActions.CreateCommitteeMeetingAttendance,
            dispatch
        ),
        validateCommitteeMeetingAttendance: bindActionCreators(
            CommitteeMeetingAttendanceActions.ValidateCommitteeMeetingAttendance,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default  connect(mapStateToProps, mapDispatchToProps)(CommitteeMeetingAttendancePage);
